(function () {
  class FreeSpinsTrailPanel extends PIXI.Container {
    constructor() {
      super();
      this._completeCallback;
      StateMachine.Create(this);
      Reflex.registerEventHandler("orientationChange", this.onOrientationChange.bind(this));

      this._currentPosition = 0;
      this._positionIncreased = false;
      this._fishermenPool = [];
      this._fishermenCreated = 0;
      this._currentNumberFishermen = 0;
      this._callback = undefined;
      this._trailSounds = ["trailIncrease1", "trailIncrease2", "trailIncrease3"];
      this._crtFishermanAnimation = undefined;
    }

    initialise() {
      const self = this;
      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });

      messageBus.subscribe("spinner:FreeSpinsStartEvent", this.setInitialTrailLevel.bind(this));
    }

    onLayoutComplete() {
      this.symbolPanels = [];
      this.fishPanels = [];

      for (let i = 0; i < 9; i++) {
        let symbolPanel = {
          halo: resourceManager.get(
            "freeSpinsTrailPanel:freeSpinsTrailPanelContainer:freeSpinsTrailPanelScale:fishermenContainer:symbol" +
              i +
              ":halo"
          ),
          highlight: resourceManager.get(
            "freeSpinsTrailPanel:freeSpinsTrailPanelContainer:freeSpinsTrailPanelScale:fishermenContainer:symbol" +
              i +
              ":symbolHighlight"
          ),
        };
        symbolPanel.halo.visible = false;
        symbolPanel.highlight.visible = false;
        this.symbolPanels.push(symbolPanel);

        if (i < 3) {
          let fishPanel = {
            backing: resourceManager.get(
              "freeSpinsTrailPanel:freeSpinsTrailPanelContainer:freeSpinsTrailPanelScale:fishContainer:symbol" +
                i +
                ":backgroundLit"
            ),
            hasEmitted: false,
            emitter: particleManager.createEmitter(
              "trailHighlight",
              "freeSpinsTrailPanel:freeSpinsTrailPanelContainer:freeSpinsTrailPanelScale:fishContainer:symbol" +
                i +
                ":backgroundLit",
              0,
              0,
              false
            ),
            dimSymbol: resourceManager.get(
              "freeSpinsTrailPanel:freeSpinsTrailPanelContainer:freeSpinsTrailPanelScale:fishContainer:symbol" +
                i +
                ":unlitFish"
            ),
            fishSymbol: resourceManager.get(
              "freeSpinsTrailPanel:freeSpinsTrailPanelContainer:freeSpinsTrailPanelScale:fishContainer:symbol" +
                i +
                ":fishSymbol"
            ),
          };
          fishPanel.fishSymbol.visible = false;
          fishPanel.backing.visible = false;
          fishPanel.emitter.particleEmitter.emit = false;
          this.fishPanels.push(fishPanel);
        }
      }
    }

    onOrientationChange() {
      this._crtFishermanAnimation?.progress(1);
    }

    setInitialTrailLevel(task) {
      const level = task.data.initialTrailLevel - 1;
      this._currentPosition = level * 3;

      for (let i = 0; i < this._currentPosition; i++) {
        this.symbolPanels[i].highlight.visible = true;
        this.symbolPanels[i].halo.visible = true;

        if (i < level) {
          this.fishPanels[i].fishSymbol.visible = true;
          this.fishPanels[i].backing.visible = true;
          this.fishPanels[i].hasEmitted = true;
        }
      }
    }

    getFisherman() {
      let graphic = undefined;

      if (this._fishermenPool.length > 0) {
        graphic = this._fishermenPool.pop();
      } else {
        graphic = resourceManager.createObject(
          "sprite",
          "fisherman" + this._fishermenCreated,
          "trailFishermenContainer",
          { fileName: "FreeSpins_Bonus/Trail_Fisherman_Lit.png", anchor: 0.5 }
        );
        this._fishermenCreated++;
      }
      return graphic;
    }

    doFishermenTrailAnimation(cb) {
      this._callback = cb;

      const self = this;

      if (this._currentPosition >= 9) {
        timerManager.addTimeout(1, function () {
          self._callback();
        });
      } else {
        if (gameController.landedFishermen.length > 0) {
          this._currentNumberFishermen = 0;
          this.addFishermanToTrail();
        } else {
          timerManager.addTimeout(1, function () {
            self._callback();
          });
        }
      }
    }

    addFishermanToTrail() {
      const nextFisherman = gameController.landedFishermen[this._currentNumberFishermen];
      const reel = nextFisherman.reel;
      const row = nextFisherman.row;

      const symPos = helpers.getSymbolPos(reel, row);
      const trailPos = helpers.getTrailPanelSymbolPos(this._currentPosition);
      const fisherman = this.getFisherman();

      soundManager.play("fishermanToTrail");

      const scaleMod = systemData.isLandscape ? 1 : 0.72;

      const duration = 1;

      this._crtFishermanAnimation = gsap
        .timeline()
        .call(() => {
          fisherman.visible = true;
          fisherman.position.x = symPos.x;
          fisherman.position.y = symPos.y;
          fisherman.scale.x = 2;
          fisherman.scale.y = 2;
          fisherman.alpha = 0;
        })
        .to(fisherman, {
          duration: 0.2,
          alpha: 1,
        })
        .to(
          fisherman,
          {
            duration,
            x: trailPos.x,
            y: trailPos.y,
            ease: "power2.out",
          },
          "<"
        )
        .to(
          fisherman.scale,
          {
            duration,
            x: scaleMod,
            y: scaleMod,
            ease: "power3.in",
          },
          "<"
        )
        .call(() => {
          soundManager.play(this._trailSounds[this._currentPosition % 3]);

          this._currentPosition++;

          this.updateTrailLevel();

          fisherman.visible = false;

          this._fishermenPool.push(fisherman);

          this._currentNumberFishermen++;

          if (this._currentNumberFishermen < gameController.landedFishermen.length && this._currentPosition < 9) {
            this.addFishermanToTrail();
          } else {
            this._callback();
          }

          this._crtFishermanAnimation = undefined;
        });
    }

    updateTrailLevel() {
      const position = this._currentPosition;
      const level = Math.floor(this._currentPosition / 3);

      for (let i = 0; i < position; i++) {
        this.symbolPanels[i].highlight.visible = true;
        this.symbolPanels[i].halo.visible = true;

        if (i < level) {
          this.fishPanels[i].fishSymbol.visible = true;
          this.fishPanels[i].backing.visible = true;

          if (!this.fishPanels[i].hasEmitted) {
            this.fishPanels[i].emitter.particleEmitter.emit = true;
            this.fishPanels[i].hasEmitted = true;
          }
        }
      }
    }

    stopEmitters(level) {
      for (let i = 0; i < level - 1; i++) {
        this.fishPanels[i].emitter.particleEmitter.emit = false;
      }
    }

    reset() {
      for (let i = 0; i < 9; i++) {
        this.symbolPanels[i].highlight.visible = false;
        this.symbolPanels[i].halo.visible = false;

        if (i < 3) {
          this.fishPanels[i].fishSymbol.visible = false;
          this.fishPanels[i].backing.visible = false;
          this.fishPanels[i].emitter.particleEmitter.emit = false;
          this.fishPanels[i].hasEmitted = false;
        }
      }
    }
  }

  create = function (json) {
    return new FreeSpinsTrailPanel();
  };

  getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType("freeSpinsTrailPanel", create, initialise, getFilesRequired);
})();
